import React, { useContext } from 'react';
import { AuthContext } from '../../common/authContext';
import { RichTextEditor, RichTextView } from '../RichText';

interface EditTextFieldProps {
  text: string;
  setText: (text: string) => void;
  placeholder?: string;
}

const EditTextField = (props: EditTextFieldProps) => {
  const { authState } = useContext(AuthContext);

  // Comments are stored in the shared S3 bucket as serialized Lexical JSON (authored in the Gold
  // app); legacy plain-text values load transparently. This app renders that content but never
  // adds styling — there is no toolbar and no rich-text formatting.
  //
  // Non-editors (Clients) get a read-only formatted view. Elevated editors (RM/admin) get a
  // toolbar-less editor that lets them change the text while keeping the stored JSON format (so
  // edits preserve, rather than clobber, any formatting authored in Gold).
  if (!authState.elevatedUser) {
    return <RichTextView value={props.text} muiStyling={{ typography: 'body1', color: 'text.primary' }} />;
  }

  return <RichTextEditor value={props.text} onChange={props.setText} placeholder={props.placeholder} />;
};

export default EditTextField;
